const activeDropzoneMixin = {
    data: () => {
        return {
            activeDropzoneLocal: null,
            activeResizeDropzoneLocal: null,
        }
    },
    props: {
        activeDropzone: {
            required: false,
        },
        activeResizeDropzone: {
            required: false
        }
    },
    watch: {
        activeDropzone: function(newVal, oldVal) {
            if(this.activeDropzoneLocal !== newVal) {
                this.activeDropzoneLocal = newVal;
            }
        },
        activeDropzoneLocal: function(newVal, oldVal) {
            this.$emit('setActiveDropzone', newVal);
        },
        activeResizeDropzone: function(newVal, oldVal) {
            if(this.activeResizeDropzoneLocal !== newVal) {
                this.activeResizeDropzoneLocal = newVal;
            }
        },
        activeResizeDropzoneLocal: function(newVal, oldVal) {
            this.$emit('setActiveResizeDropzone', newVal);
        }
    },

    methods: {
        setActiveDropzone(e) {
            this.activeDropzoneLocal = e;
            this.$emit('setActiveDropzone', e);
        },
        setActiveResizeDropzone(e) {
            this.activeResizeDropzoneLocal = e;
            this.$emit('setActiveResizeDropzone', e);
        },
        getActiveDropzone() {
            return this.activeDropzoneLocal;
        },
        getActiveResizeDropzone() {
            return this.activeResizeDropzoneLocal;
        }
    },
    created() {
        this.activeDropzoneLocal = this.activeDropzone;
    }
};

export default activeDropzoneMixin;